// Guías de Aprender · Tienda, Premium, ajustes y ayuda (2026-10-18).

export const AYUDA_GUIDES = [
  {
    slug: "tienda",
    theme: "ayuda",
    nav: "La Tienda",
    title: "La Tienda de XIMA: skins, ofertas del día y más",
    description:
      "Qué hay en la Tienda de XIMA: bloques especiales y comunes, animaciones, texturas, tarjetas regalo y el juego de mesa físico, con tres ofertas que cambian cada día.",
    h1: "La Tienda",
    intro:
      "En la Tienda consigues nuevos estilos para tus partidas. Todo lo que compras es estético: cambia el aspecto del juego, nunca las reglas.",
    sections: [
      {
        h: "Las categorías",
        list: [
          "Bloques especiales y bloques comunes: nuevos diseños para tus piezas.",
          "Animaciones: cómo se mueven y aparecen tus bloques.",
          "Texturas: para el tablero y las paredes.",
          "Tarjetas: tarjetas regalo.",
          "Juego de mesa: la versión física de XIMA, con su galería de fotos.",
        ],
        after: [
          "Cada artículo indica su rareza (común, raro, épico o legendario) según la categoría.",
        ],
      },
      {
        h: "Ofertas del día",
        p: [
          "Arriba aparecen tres artículos destacados que cambian cada medianoche, con una cuenta atrás hasta el cambio.",
        ],
      },
      {
        h: "Monedas y saldo",
        p: [
          "Los diseños se pagan con las monedas del juego. Las consigues, por ejemplo, con las recompensas de los puzzles, ganando retos a tus amigos o con Invita y gana. Las monedas solo valen dentro de XIMA: no son dinero real.",
        ],
      },
      {
        h: "Usar lo que compras",
        p: [
          "Lo que compras queda disponible en Modo Diseñar, donde lo aplicas a tus bloques o a tu tablero. Además de lo que compras, hay muchos diseños gratis.",
        ],
      },
    ],
    faqs: [
      ["¿Lo que compro en la Tienda da ventaja?", "No. Todo es estético."],
      ["¿Las monedas son dinero real?", "No. Solo se usan dentro de XIMA."],
      ["¿Dónde aplico un skin que he comprado?", "En Modo Diseñar."],
    ],
    related: ["perfil", "premium", "amigos", "puzzles"],
    cta: { label: "Modo Diseñar", slug: "perfil" },
    legacy: [
      "tienda/skins",
      "tienda/recompensas",
      "tienda/bonos",
      "tienda/saldo",
      "tienda/comprar-skin",
      "tienda/equipar-skin",
      "tienda/gift-cards",
      "tienda/reclamar-recompensa",
      "solucion/tienda-no-muestra-recompensas",
    ],
  },
  {
    slug: "premium",
    theme: "ayuda",
    nav: "Premium",
    title: "XIMA Premium: análisis, videos y puzzles sin límite",
    description:
      "Qué incluye XIMA Premium por 2 USD al mes: análisis de partidas con el bot, videos de tus partidas y puzzles sin límite. Cómo pagar con PayPal y cómo cancelar.",
    h1: "Premium",
    intro:
      "XIMA se puede jugar gratis. Premium es una suscripción opcional para quien quiere estudiar más a fondo sus partidas y, de paso, apoyar el juego.",
    sections: [
      {
        h: "Qué incluye",
        table: {
          head: ["", "Sin Premium", "Con Premium"],
          rows: [
            ["Análisis de partidas con el bot", "3 nuevos al día", "Sin límite"],
            ["Descargar el video de una partida", "No", "Sin límite"],
            ["Puzzles", "1 nuevo al día", "Todos los que quieras"],
            ["Jugar partidas, torneos y bots", "Sí", "Sí"],
          ],
        },
      },
      {
        h: "Precio y pago",
        p: [
          "Premium cuesta 2 USD al mes. Se paga con PayPal, con tu cuenta de PayPal o con tarjeta. Al volver a XIMA después de pagar, Premium se activa solo en tu cuenta, sin esperar a nadie. Cada mes que pagas sigues siendo Premium.",
          "Si tienes problemas para pagar, escríbenos por WhatsApp o por correo con tu nombre de usuario de XIMA.",
        ],
      },
      {
        h: "Cancelar",
        p: [
          "Puedes cancelar la suscripción cuando quieras desde la página Premium. PayPal deja de cobrarte y sigues siendo Premium hasta el final del periodo que ya pagaste.",
        ],
      },
      {
        h: "Por qué existe",
        p: [
          "Tu membresía ayuda a seguir creando juegos, torneos y mejoras para todos.",
        ],
      },
    ],
    faqs: [
      ["¿Cuánto cuesta Premium?", "2 USD al mes."],
      ["¿Cómo se paga?", "Con PayPal, con tu cuenta o con tarjeta."],
      ["¿Puedo cancelar cuando quiera?", "Sí. Sigues siendo Premium hasta el final del mes que pagaste."],
      ["¿Necesito Premium para jugar?", "No. Jugar es gratis."],
    ],
    related: ["analizar-partida", "descargar-video", "puzzles", "soporte"],
    cta: { label: "Analizar una partida", slug: "analizar-partida" },
  },
  {
    slug: "ajustes",
    theme: "ayuda",
    nav: "Ajustes",
    title: "Ajustes de XIMA: sonido, animaciones, cámara e idioma",
    description:
      "Qué puedes cambiar en los Ajustes de XIMA: sonido, animaciones, seguir cámara, velocidad de los bloques, control por voz e idioma (es, en, ru, de).",
    h1: "Ajustes",
    intro:
      "En Ajustes dejas el juego a tu gusto. Todo está en una sola pantalla y los cambios se guardan solos.",
    sections: [
      {
        h: "Preferencias del juego",
        list: [
          "Sonido del juego.",
          "Animaciones.",
          "Seguir cámara: la vista sigue a los bloques que se mueven.",
          "Velocidad de las animaciones de los bloques, con un deslizador.",
          "Control por voz.",
        ],
        after: [
          "La velocidad de las animaciones también se puede cambiar durante una partida, y el cambio se guarda igual que en Ajustes.",
        ],
      },
      {
        h: "Idioma",
        p: [
          "XIMA está en español, inglés, ruso y alemán. Elige el tuyo y la interfaz cambia al momento; el juego lo recordará la próxima vez. Si algo no cambia, recarga la página.",
        ],
      },
      {
        h: "Contacto",
        p: [
          "Desde Ajustes también puedes copiar el correo de soporte, info@juegoxima.com, o ir directamente al centro de Soporte.",
        ],
      },
    ],
    faqs: [
      ["¿Tengo que guardar los ajustes?", "No. Se guardan solos."],
      ["¿Los ajustes cambian las reglas?", "No. Solo cambian cómo ves y oyes el juego."],
    ],
    related: ["control-por-voz", "compatibilidad-movil", "soporte"],
    cta: { label: "Control por voz", slug: "control-por-voz" },
    legacy: ["idiomas", "solucion/idioma-no-cambia"],
  },
  {
    slug: "control-por-voz",
    theme: "ayuda",
    nav: "Control por voz",
    title: "Control por voz en XIMA: juega hablando",
    description:
      "Cómo activar el control por voz de XIMA y qué puedes decir: girar y acercar la cámara, mirar una cara del tablero, lanzar los dados, mover y confirmar.",
    h1: "Control por voz",
    intro:
      "Con el control por voz puedes manejar la cámara, lanzar los dados y hacer otras acciones hablando, sin tocar la pantalla.",
    sections: [
      {
        h: "Cómo se activa",
        list: [
          "Abre Ajustes y activa Control por voz (también puedes hacerlo durante la partida).",
          "Acepta el permiso de micrófono que te pide el navegador.",
          "Habla con frases cortas y claras.",
        ],
      },
      {
        h: "Qué puedes decir",
        defs: [
          ["Cámara", "«Girar izquierda», «girar derecha», «media vuelta», «acercar» o «más zoom», «alejar» o «menos zoom», «centrar tablero»."],
          ["Caras del tablero", "«Mirar cara uno», «cara dos», «cara tres» o «cara cuatro»."],
          ["Dados", "«Lanzar dados», «tirar dados» o simplemente «dados» (en los modos con dados)."],
          ["Acciones", "«Seleccionar» o «confirmar» para aceptar, «cancelar» o «atrás» para deshacer la selección."],
          ["Mover", "«Mover» seguido de la dirección, por ejemplo «mover arriba»."],
        ],
        after: [
          "La voz es solo otra forma de dar órdenes: la jugada sigue teniendo que cumplir las reglas. Si el juego entiende otra cosa, no confirmes y usa los controles normales.",
        ],
      },
      {
        h: "Privacidad",
        p: [
          "El control por voz no guarda tu audio ni un historial de lo que dices. Activa el micrófono solo cuando quieras usarlo.",
        ],
      },
      {
        h: "Si no te entiende",
        list: [
          "Comprueba que diste permiso al micrófono en el navegador.",
          "Prueba con otro navegador: el reconocimiento de voz no funciona igual en todos.",
          "Habla un poco más despacio y cerca del micrófono.",
        ],
      },
    ],
    faqs: [
      ["¿El control por voz funciona en todos los navegadores?", "No en todos. Depende de que el navegador tenga reconocimiento de voz y de que des permiso al micrófono."],
      ["¿Se guarda lo que digo?", "No se guarda tu audio ni un historial de tus órdenes."],
    ],
    related: ["chat-de-voz", "ajustes", "compatibilidad-movil"],
    cta: { label: "Chat de voz", slug: "chat-de-voz" },
    legacy: [
      "voz/comandos-camara",
      "voz/comandos-dados",
      "voz/comandos-movimiento",
      "voz/permisos-microfono",
      "solucion/microfono-bloqueado",
    ],
  },
  {
    slug: "compatibilidad-movil",
    theme: "ayuda",
    nav: "Jugar en el móvil",
    title: "Jugar XIMA en el móvil: app, navegador y consejos",
    description:
      "Cómo jugar XIMA en el móvil o la tablet: desde el navegador o con la app de Android, en vertical u horizontal, y qué hacer si el tablero 3D no carga.",
    h1: "Jugar en el móvil",
    intro:
      "XIMA funciona en el móvil y en la tablet, desde el navegador y sin instalar nada. En Android también tienes una app.",
    sections: [
      {
        h: "Navegador o app",
        p: [
          "Abre juegoxima.com en el navegador de tu móvil y juega igual que en el ordenador. Si usas Android, puedes descargar la app desde la opción Descargar app móvil del menú.",
        ],
      },
      {
        h: "Vertical u horizontal",
        p: [
          "En vertical el menú pasa a una barra en la parte inferior y algunos paneles quedan más abajo: desliza para verlos. En horizontal hay más espacio para el tablero, las repeticiones y los paneles de la partida.",
        ],
      },
      {
        h: "Si el tablero no carga",
        p: [
          "El tablero 3D necesita un navegador moderno con los gráficos 3D activados y algo de memoria libre. Si se queda en blanco o no termina de cargar:",
        ],
        list: [
          "Espera a que termine de cargar antes de tocar varios botones seguidos.",
          "Recarga la página una vez.",
          "Actualiza el navegador o prueba con otro (Chrome, Edge, Safari o Firefox).",
          "Cierra otras pestañas o aplicaciones pesadas.",
          "Evita el modo privado o de incógnito si tu navegador bloquea ahí el almacenamiento.",
          "Si sigue sin funcionar, escríbenos desde Soporte con el modelo de móvil y el navegador que usas.",
        ],
      },
    ],
    faqs: [
      ["¿Hay app de XIMA?", "Sí, para Android, desde el menú del juego. En cualquier móvil puedes jugar también desde el navegador."],
      ["¿Por qué no carga el tablero en mi móvil?", "Normalmente por un navegador antiguo, poca memoria libre o gráficos 3D desactivados. Prueba los pasos de esta guía."],
    ],
    related: ["solucion-de-problemas", "ajustes", "soporte"],
    cta: { label: "Solución de problemas", slug: "solucion-de-problemas" },
    legacy: [
      "movil/descargar-app",
      "movil/orientacion",
      "movil/webgl",
      "movil/jugar-en-celular",
      "solucion/unity-no-carga",
      "solucion/webgl-no-compatible",
    ],
  },
  {
    slug: "cuenta",
    theme: "ayuda",
    nav: "Tu cuenta",
    title: "Tu cuenta de XIMA: registro, acceso y seguridad",
    description:
      "Cómo crear tu cuenta de XIMA, iniciar sesión, usar dos cuentas en el mismo navegador, jugar como invitado y mantener tu cuenta segura.",
    h1: "Tu cuenta",
    intro:
      "Con una cuenta de XIMA guardas tu historial, tus estadísticas, tu CIMAX, tus monedas y tus diseños.",
    sections: [
      {
        h: "Crear la cuenta",
        list: [
          "Abre la pantalla de registro.",
          "Escribe tu correo y una contraseña.",
          "Lee y acepta los Términos y condiciones.",
          "Escribe el código que te llega al correo para verificar la cuenta.",
        ],
        after: [
          "Cada correo puede tener una sola cuenta. Si te registras con un correo que ya usaste, el juego te avisa de que la cuenta anterior quedará archivada.",
        ],
      },
      {
        h: "Jugar como invitado",
        p: [
          "Si un amigo te pasa el enlace de una partida, de un torneo o de un puzzle, puedes jugar sin registrarte. Al terminar, el juego te propone crear tu cuenta y conservas lo que jugaste.",
        ],
      },
      {
        h: "Dos cuentas en el mismo navegador",
        p: [
          "Cada pestaña puede tener su propia sesión. Para entrar con otra cuenta en una pestaña nueva sin cerrar la que tienes abierta, usa juegoxima.com/login?otra-cuenta=1.",
        ],
      },
      {
        h: "Seguridad",
        list: [
          "No compartas tu contraseña ni los códigos de verificación con nadie, tampoco con Soporte.",
          "Tu código de jugador sí lo puedes compartir: solo sirve para que te encuentren.",
          "Una cuenta solo puede tener una sesión activa a la vez: si entras desde otro sitio, la sesión anterior se cierra.",
        ],
      },
      {
        h: "Privacidad y términos",
        p: [
          "Tus repeticiones y tu historial de partidas son públicos para que otros jugadores puedan aprender de ellos, y tu CIMAX aparece en el ranking. Tus datos personales no se muestran. Consulta los Términos y condiciones desde la pantalla de registro.",
        ],
      },
    ],
    faqs: [
      ["¿Puedo tener dos cuentas con el mismo correo?", "No. Cada correo tiene una sola cuenta."],
      ["¿Puedo jugar sin cuenta?", "Sí, como invitado con un enlace. Para guardar tus partidas, crea tu cuenta."],
    ],
    related: ["perfil", "soporte", "preguntas-frecuentes"],
    cta: { label: "Tu perfil", slug: "perfil" },
    legacy: [
      "cuenta/crear-cuenta",
      "cuenta/iniciar-sesion",
      "cuenta/cerrar-sesion",
      "cuenta/terminos-y-condiciones",
      "cuenta/privacidad",
      "cuenta/seguridad",
    ],
  },
  {
    slug: "soporte",
    theme: "ayuda",
    nav: "Soporte",
    title: "Soporte de XIMA: cómo pedir ayuda",
    description:
      "Cómo contactar con el soporte de XIMA: el centro de ayuda con preguntas frecuentes, las solicitudes numeradas con su estado y el correo info@juegoxima.com.",
    h1: "Soporte",
    intro:
      "Si algo no funciona o tienes una duda, el centro de Soporte es el lugar para pedir ayuda.",
    sections: [
      {
        h: "El centro de ayuda",
        p: [
          "En Soporte encontrarás respuestas a las preguntas más comunes y un buscador que también busca en las guías de Aprender. Muchas dudas se resuelven ahí al momento.",
        ],
      },
      {
        h: "Enviar una solicitud",
        list: [
          "Elige el tema (cuenta, partidas, tienda, Premium…).",
          "Describe el problema: qué estabas haciendo, en qué sección y qué pasó.",
          "Añade el navegador y el dispositivo si es un problema técnico.",
          "Envíala. Cada solicitud tiene un número y un estado (nueva, en revisión, respondida o cerrada).",
        ],
        after: [
          "Cuando te respondamos verás un aviso en el menú. Solo tú ves tus solicitudes.",
        ],
      },
      {
        h: "Por correo",
        p: ["También puedes escribir a info@juegoxima.com."],
      },
      {
        h: "Nunca envíes",
        p: ["Tu contraseña, códigos de verificación ni datos de pago. Nadie de XIMA te los pedirá nunca."],
      },
    ],
    faqs: [
      ["¿Cuál es el correo de XIMA?", "info@juegoxima.com."],
      ["¿Dónde veo la respuesta a mi solicitud?", "En Soporte, en tus solicitudes. Un aviso en el menú te dice cuándo hay respuesta."],
    ],
    related: ["solucion-de-problemas", "preguntas-frecuentes", "cuenta"],
    cta: { label: "Solución de problemas", slug: "solucion-de-problemas" },
  },
  {
    slug: "solucion-de-problemas",
    theme: "ayuda",
    nav: "Solución de problemas",
    title: "Solución de problemas en XIMA",
    description:
      "Qué hacer si el tablero de XIMA no carga, no puedes mover un bloque, no aparecen los dados, el micrófono no va o una partida no aparece en tu historial.",
    h1: "Solución de problemas",
    intro:
      "Los problemas más comunes y cómo resolverlos en un minuto. Si ninguno de estos pasos te sirve, escríbenos desde Soporte.",
    sections: [
      {
        h: "El tablero no carga",
        list: [
          "Espera unos segundos: la primera vez tarda más.",
          "Recarga la página una vez.",
          "Actualiza el navegador o prueba con otro.",
          "Cierra pestañas pesadas, sobre todo en el móvil.",
        ],
      },
      {
        h: "No puedo mover un bloque",
        list: [
          "Comprueba que es tu turno y, en un modo con dados, que ya lanzaste.",
          "Mira si el bloque tiene otro encima: los bloques dominados no se mueven.",
          "Revisa la regla de la altura: en cada paso solo se sube un bloque de altura.",
          "En Modo Azar, el destino tiene que estar exactamente a los pasos del dado.",
          "Tu especial no puede pasar por encima del especial rival.",
        ],
      },
      {
        h: "No aparecen los dados",
        p: [
          "Los dados solo aparecen en Azar, en Cienzar (cuando eliges lanzar) y para el bando de Azar en Ciencia V/S Azar. En Modo Ciencia no hay dados.",
        ],
      },
      {
        h: "El micrófono no funciona",
        list: [
          "Da permiso al micrófono en el navegador (normalmente, en el candado de la barra de direcciones).",
          "Cierra otras aplicaciones que lo estén usando.",
          "Recarga la página.",
        ],
      },
      {
        h: "Una partida no aparece en el historial",
        list: [
          "Las partidas aparecen cuando terminan.",
          "Si jugaste como invitado, regístrate para guardarlas.",
          "Recarga la página.",
        ],
      },
      {
        h: "No puedo entrar en una partida",
        list: [
          "Puede que esté llena o ya haya empezado.",
          "Revisa la contraseña, si la tiene.",
          "Sal antes de cualquier otra partida en la que estés.",
        ],
      },
      {
        h: "Antes de escribir a Soporte",
        p: [
          "Anota en qué sección estabas, qué hiciste, qué pasó y la hora aproximada, junto con tu navegador y tu dispositivo. Una captura de pantalla ayuda mucho, siempre que no muestre datos privados.",
        ],
      },
    ],
    faqs: [
      ["¿Por qué el juego no me deja mover?", "Normalmente porque no es tu turno, el bloque está dominado o el movimiento sube más de una altura de bloque en algún paso."],
    ],
    related: ["soporte", "compatibilidad-movil", "reglas/movimientos", "control-por-voz"],
    cta: { label: "Contactar con Soporte", slug: "soporte" },
  },
];
